export const TEST_URL = 'kmartova.dareu.marvel.makeit-dev.ru/local/templates/f-plus/build';

export const Resolutions = {
    ALL: () => window.matchMedia(`(min-width: 320px)`).matches,
    IS_DP_LG: () => window.matchMedia(`(min-width: 1920px)`).matches,
    IS_NOT_DP_LG: () => window.matchMedia(`(min-width: 1260px) and (max-width: 1919px)`).matches,
    IS_DP: () => window.matchMedia(`(min-width: 1260px)`).matches,
    IS_TAB: () => window.matchMedia(`(max-width: 1259px)`).matches,
    IS_TAB_ONLY: () => window.matchMedia(`(min-width: 768px) and (max-width: 1259px)`).matches,
    IS_NOT_MOB: () => window.matchMedia(`(min-width: 768px)`).matches,
    IS_MOB: () => window.matchMedia(`(max-width: 767px)`).matches,
    IS_MOB_VPS: () => window.matchMedia(`(max-width: 499px)`).matches,
};

export const ScreenWidth = {
  TABLET: 768,
  MOB: 375,
  MOB_VPS: 500
};

export const Timeout = {
    FADE: 150,
    ANIMATION_TIMEOUT: 500,
    SHORT_TIMEOUT: 10,
    MED_TIMEOUT: 150,
    LONG_TIMEOUT: 1000,
    SUPERLONG_TIMEOUT: 3000,
    ANIMATION_TOGGLE: 300,
};

export const ErrorMessages = {
    REQUIRED: `Заполните это поле`,
    EMAIL: `Введите корректный email`,
    MIN_LENGTH: `Введите как минимум 2 символа`,
    TEL_COMPLETE: `Заполните телефон полностью`,
    FILE_MAX_SIZE: `Файл слишком большого размера`,
    FILE_TYPE: `Неподходящий формат файла`,
    LETTERS_ONLY: `Допустимо использование только букв`,
    CHECKBOX_REQUIRED: `Не выбран чекбокс`,
    PASSWORD_MATCH: `Пароли не совпадают`,
};
